$(function () {

    // Undertaker recommend
    $('.recommend-button').on('click', function() {
        let button = $(this);
        let undertakerId = button.data('id');
        let undertakerName = button.data('name');
        if (undertakerId) {
            $.ajax({
                method: 'GET',
                url: Routing.generate('undertaker_recommend', {'id': undertakerId}),
                success: function (data) {
                    if (data === 'OK') {
                        button.parent().next('.confirm-text').show();
                        button.parent().hide();

                        let trackingData = {
                            'event': 'recommandation_submit',
                            'id_pompe_funebre': undertakerId + ' - ' + undertakerName,
                        };
                        console.log('Tracking Data: ' + JSON.stringify(trackingData))
                        // Tracking MTM
                        if (typeof _mtm !== 'undefined') {
                            _mtm.push(trackingData);
                        }
                    }
                }
            });
        }
    });

    // Undertaker config start
    let configContent = $('#config-content');
    if (configContent.length) {
        let configLoader = $('#config-loader');
        let inquiryHash = configContent.data('inquiry-hash');
        let inquiryUniqid = configContent.data('inquiry-uniqid');

        if (inquiryHash) {
            configLoader.addClass('loading');
            $.ajax({
                method: 'GET',
                url: Routing.generate('config_step', {'hash': inquiryHash, 'uniqid': inquiryUniqid}),
                success: function (data) {
                    if (data.status === 'success') {
                        configLoader.addClass('loaded');
                        if (data.html) {
                            configContent.html(data.html);
                            configLoader.removeClass('loading loaded');
                        }
                    }
                }
            });
        }
    }

    configContent.on('click', '.answers .button', function() {
        let trackingData = {
            'event': 'configuration_start',
            'id_pompe_funebre': configContent.data('undertaker-id'),
        };
        console.log('Tracking Data: ' + JSON.stringify(trackingData))
        // Tracking MTM
        if (typeof _mtm !== 'undefined') {
            _mtm.push(trackingData);
        }
    })
});